import RegisterSyncUp from "../components/RegisterSyncUp";

const SyncUp = () => {
  return (
    <RegisterSyncUp />          
  );
};
export default SyncUp;
